export const blockIconsTextformattingPostAddNew = (
	<span className='material-symbols-outlined'>post_add</span>
);
